import { Box, Grid } from '@material-ui/core';

import { Backdrop } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';

import { useStyles } from './CheckInForm.styles';
import { Complete } from './Complete';
import { Additional, Terms } from './Form';
import { Information } from './Information';

import { FormikProps, useFormik } from 'formik';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import GuardianshipModal from 'shared/components/GuardianshipModal/GuardianshipModal';
import SizeCard from 'shared/components/SizeCard/SizeCard';
import { CheckinSteps } from 'shared/enums/CheckinSteps';
import { IAuditionScheduleCreatePayload } from 'shared/interfaces/IAuditionSchedule';
import { ICheckInResponsePayload } from 'shared/interfaces/ICheckIn';
import { ISingleProjectResponsePayload } from 'shared/interfaces/IProject';
import { useAppSelector } from 'shared/redux/store';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import { checkInService } from 'shared/services/checkInService';
import { ls } from 'shared/utils/ls';
import * as yup from 'yup';

const { createAuditionSchedule } = auditionScheduleService();
const { markAsCheckIn } = checkInService();

type Props = {
  activeStep: number;
  projectId: string;
  checkinData?: ICheckInResponsePayload;
  pData?: ISingleProjectResponsePayload;
  sessionId?: string;
};

const CheckInForm: React.FC<Props> = ({ projectId, checkinData, activeStep, pData, sessionId }) => {
  const { removeLS, getLS } = ls();
  const { mutate: mutateMarkCheckIn } = markAsCheckIn();
  const { app: appState } = useAppSelector((state) => state);
  const { members } = appState.guardian;
  const classes = useStyles();
  const { mutateAsync, isLoading: createIsLoading } = createAuditionSchedule();
  const queryClient = useQueryClient();
  const [loading, setloading] = useState(false);
  const history = useHistory();
  const [showSelectProfile, setShowSelectProfile] = useState(false);
  const [hideSelectProfile, setHideSelectProfile] = useState(false);

  const initialValues: IAuditionScheduleCreatePayload = {
    role_id: '',
    profile_id: '',
  };

  const ndaRequired = pData?.data.attributes.ongoing_session.data.attributes.required_signed_nda;
  const byPassNDA = async () => {
    mutateMarkCheckIn(
      { sessionId: sessionId as string },
      {
        onSuccess: (values) => {
          removeLS('ghosted_session_id');
          removeLS('ghosted_profile_id');
          queryClient
            .invalidateQueries(['projects', 'sessions/check_in'])
            .then(() => history.push(`${CheckinSteps.COMPLETE}`));
          setloading(false);
        },
        onError: (e) => {
          console.error(e);
          const { response } = e;
          const { data } = response as any;
          const { errors } = data;
          if (errors.audition_schedule && errors.audition_schedule.includes('is already checked in')) {
            history.push(`${CheckinSteps.COMPLETE}`);
          }
          setloading(false);
        },
        // onSettled: () => setSaving(false),
      },
    );
  };

  const handleNext = (step: CheckinSteps) => {
    setloading(true);
    if (step === CheckinSteps.TERMS && !ndaRequired) return byPassNDA();
    history.push(`${step}`);
    setloading(false);
  };

  const handleSubmit = async (values: IAuditionScheduleCreatePayload) => {
    await mutateAsync(
      { sessionId: pData?.data.attributes.ongoing_session.data.id as string, payload: values },
      {
        onSuccess: () => {
          console.log('form handle submit', values);
          queryClient.invalidateQueries('sessions/check_in').then(() => {
            console.log('fire then');
            setTimeout(() => {
              console.log('next');
              // captureMessage({
              //   message: 'user check in size card information',
              //   data: values,
              // });
              setloading(false);
              handleNext(CheckinSteps.QUESTIONS);
            }, 500);
          });
        },
        onSettled: () => {
          setTimeout(() => {
            setloading(false);
          }, 500);
        },
      },
    );
  };

  const createResumeValidationSchema: yup.SchemaOf<IAuditionScheduleCreatePayload> = yup.object().shape({
    // representation_type: yup.mixed<RepresentationType>().oneOf(Object.values(RepresentationType)).required(),
    role_id: yup.string().required(),
    profile_id: yup.string().required(),
  });

  const form: FormikProps<IAuditionScheduleCreatePayload> = useFormik({
    initialValues,
    // validateOnBlur: true,
    // enableReinitialize: true,
    validationSchema: createResumeValidationSchema,
    onSubmit: (values) => {
      if (checkinData?.data) {
        handleNext(CheckinSteps.QUESTIONS);
      } else {
        setloading(true);
        handleSubmit(values);
      }
    },
  });

  const auditionData = checkinData ? checkinData.data?.attributes.audition.data : null;
  useEffect(() => {
    if (auditionData) {
      const role_id = auditionData.attributes.casting_role.data.id;
      const profile_id = auditionData.attributes.profile.data.id;

      form.setFieldValue('profile_id', profile_id);
      form.setFieldValue('role_id', role_id);
    }
  }, [auditionData]);

  useEffect(() => {
    if (members.length && !getLS('prev_url') && activeStep === 1) setShowSelectProfile(true);
  }, [activeStep]);

  const handleCloseModal = () => {
    setShowSelectProfile(false);
    setHideSelectProfile(true);
  };

  if (loading) return <Backdrop isLoading />;

  return (
    <>
      <GuardianshipModal showSelectProfile={showSelectProfile} close={handleCloseModal} pageName="like to Check In" />
      <Grid item className={classes.root}>
        {form.values.profile_id === '' ||
        form.values.role_id === '' ||
        (!auditionData && (form.values.profile_id === '' || form.values.role_id === '')) ? (
          <Grid item className={`${classes.container} ${classes.information}`}>
            <Information
              createIsLoading={createIsLoading}
              form={form}
              projectName={pData?.data.attributes.name}
              pData={pData}
              projectId={projectId}
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid
          item
          className={`${classes.container} ${activeStep > 3 ? classes.completeBody : classes.body}`}
          style={{ opacity: form.values.profile_id === '' || form.values.role_id === '' ? 0.5 : 1 }}
        >
          {activeStep > 3 ? (
            <Complete info={checkinData?.data.attributes.audition.data.attributes.profile.data} />
          ) : (
            <Box style={{ position: 'relative' }}>
              {(form.values.profile_id === '' || form.values.role_id === '') && (
                <Box style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 99 }}></Box>
              )}
              {/* <Grid item className={classes.header}> */}
              {/* <Grid item>
                  <Typography fontSize={16}>Please complete the following steps to check-in</Typography>
                </Grid> */}
              {/* <Grid item className={classes.stepperContainer}>
                    <Stepper steps={4} active={activeStep} />`
                  </Grid> */}
              {/* </Grid> */}
              <Grid item>
                {
                  activeStep === 1 ? (
                    // <Personal personalDone={() => form.handleSubmit()} />
                    <SizeCard onSave={() => form.handleSubmit()} checkinSelfTapes />
                  ) : activeStep === 2 ? (
                    <Additional
                      roleId={form.values.role_id}
                      auditionID={checkinData?.data?.id || ''}
                      handleNext={(noQuestion?: boolean) =>
                        // If no questions and nda is not required just redirect to Complete
                        handleNext(
                          !ndaRequired && noQuestion !== undefined && noQuestion
                            ? CheckinSteps.COMPLETE
                            : CheckinSteps.TERMS,
                        )
                      }
                      handlePrev={() => handleNext(CheckinSteps.SIZE_CARD)}
                      projectId={projectId}
                    />
                  ) : activeStep === 3 ? (
                    <Terms
                      nda={pData?.data.attributes.ongoing_session.data.attributes.nda_content}
                      ndaRequired={pData?.data.attributes.ongoing_session.data.attributes.required_signed_nda}
                      data={checkinData?.data}
                      handleNext={() => handleNext(CheckinSteps.COMPLETE)}
                      handlePrev={() => handleNext(CheckinSteps.QUESTIONS)}
                      sessionId={
                        pData && pData?.data.attributes.ongoing_session.data.id
                          ? pData?.data.attributes.ongoing_session.data.id
                          : ''
                      }
                    />
                  ) : null
                  // history.push(`${ROUTES.TALENT.CHECKIN}/${projectId}/${sessionId}/${CheckinSteps.SIZE_CARD}`)
                }
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>
      {/* ) : (
        <Backdrop isLoading={isLoading} />
      )} */}
    </>
  );
};

export default CheckInForm;
